import { Direction } from '@modules/common/types';

export function directionToString(direction: Direction) {
  if (direction === Direction.Right) {
    return 'right';
  }

  if (direction === Direction.Left) {
    return 'left';
  }

  if (direction === Direction.Top) {
    return 'top';
  }

  return 'bottom';
}
